import React from "react";
import "./interviewLogsCardView.scss";

const InterviewLogsHistoryHeader = () => {
  return (
    <div className="ilcv-header">
      <div className="ilcv-header__titles">
        <h1 className="ilcv-title">Interview History</h1>
        <p className="ilcv-subtitle">
          Review past interviews and track performance across your organization.
        </p>
      </div>
    </div>
  );
};

export default InterviewLogsHistoryHeader;
